import type { MantineThemeOverride } from '@mantine/core';
import { modifyOpacityOfRgbaColor } from '../../utils';

export const Popover: MantineThemeOverride['components'] = {
	Popover: {
		styles: (theme) => ({
			dropdown: {
				borderRadius: theme.other.borderRadius.md,
				boxShadow: `0px 0px 0px 1px ${theme.other.getColor('shadow/border')},
   0px 1px 4px 0px ${modifyOpacityOfRgbaColor(theme.other.getColor('shadow/button-shadow'), 0.08)},
   0px 4px 8px 0px ${modifyOpacityOfRgbaColor(theme.other.getColor('shadow/button-shadow'), 0.08)}`,
				border: 'none',
			},
		}),
	},
};
